import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import { ToastService } from '../shared/toast.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-code-confirmation',
  templateUrl: './code-confirmation.component.html',
  styleUrls: ['./code-confirmation.component.scss']
})
export class CodeConfirmationComponent {
   videoUrl!: SafeResourceUrl;

email: string = '';
  code: string = '';
  submitted = false;
  verifying = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private toast: ToastService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
     const youtubeLink = 'https://www.youtube.com/embed/rL4zzMLGBCs';
     this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(youtubeLink);

    this.route.queryParams.subscribe(params => {
      this.email = params['email'] || '';
    });
  }

  onConfirmCode() {
    this.submitted = true;
    if (!this.code) return;

    this.verifying = true;
    this.commonService.verifyCode({ email: this.email, code: this.code }).subscribe({
      next: () => {
        this.verifying = false;
        this.toast.showSuccess('Account verified successfully! Please login.');
        this.router.navigate(['/login'], { queryParams: { email: this.email } });
      },
      error: (err) => {
        this.verifying = false;
        console.error('Verification failed', err);

        this.toast.showError('Invalid or expired code. Please try again.');

      }
    });
  }

  resendCode() {
    this.commonService.resendCode(this.email).subscribe({
      next: () => this.toast.showSuccess('Code resent to your email.'),
      error: () => this.toast.showError('Error resending code. Please try again later.')
    });
  }

}
